import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import emptyVideosImage from 'assets/images/salty-placeholder.png'

export const VideoListEmptyState = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Container role='status' aria-label={t('videos.emptyState')}>
      <EmptyImage
        src={emptyVideosImage}
        alt=''
        aria-hidden='true'
      />
      <EmptyTitle>{t('videos.emptyStateTitle')}</EmptyTitle>
      <EmptyMessage>{t('videos.emptyState')}</EmptyMessage>
    </Container>
  )
}

export default VideoListEmptyState

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  width: 100%;
  min-height: 320px;
  padding: 32px 16px;
  text-align: center;
`

const EmptyImage = styled.img`
  width: 180px;
  height: auto;
  object-fit: contain;
  margin-bottom: 24px;
`

const EmptyTitle = styled.h2`
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.main.heading};
`

const EmptyMessage = styled.p`
  margin: 0;
  max-width: 360px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.main.text};
`
